import { css } from '@emotion/react';

import { COLORS2, LAYOUT2 } from '@/Client/Styles';

const HERO_WITH_FIELDS_SUMMARY_STYLE = css`
  label: HERO_WITH_FIELDS_SUMMARY_STYLE;
  background-color: var(--background);
  color: var(--text);
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  flex-shrink: 0;
`;

const HERO_IMAGE_CONTAINER_STYLE = css`
  label: HERO_IMAGE_CONTAINER_STYLE;
  width: 400px;
  min-width: 300px;
  height: 100%;
  flex-shrink: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 1020px) {
    width: 100%;
  }
`;

const FIELDS_COLUMN_STYLE = css`
  label: FIELDS_COLUMN_STYLE;
  flex: 1;
  min-width: 500px;
  display: flex;
  padding: ${LAYOUT2.spacing2}px;
  flex-direction: column;

  @media (max-width: 1000px) {
    width: 100%;
    min-width: unset;
  }
`;

const FIELDS_ROWS_STYLE = css`
  label: FIELDS_ROWS_STYLE;
  display: flex;
  flex-direction: column;
  gap: ${LAYOUT2.spacing2}px;
  width: 100%;
`;

const FIELD_ROW_STYLE = css`
  label: FIELD_ROW_STYLE;
  display: flex;
  align-items: center;
  gap: ${LAYOUT2.spacing2}px;


  @media (max-width: 600px) {
    flex-direction: column;

  }
`;

/**
 * Reusable layout component for displaying a hero image with form fields
 * @param heroUri - URL for the hero image
 * @param fieldRows - Array of arrays of React elements, each inner array represents a row of fields
 */
export const HeroImageWithPropsCard = ({ heroUri, fieldRows }: { heroUri?: string; fieldRows: React.ReactNode[][] }) => (
  <div css={HERO_WITH_FIELDS_SUMMARY_STYLE}>
    <div
      css={HERO_IMAGE_CONTAINER_STYLE}
      style={{ backgroundImage: heroUri ? `url(${heroUri})` : undefined, backgroundColor: COLORS2.alwaysDark.background.light }}
    />
    <div css={FIELDS_COLUMN_STYLE}>
      <div css={FIELDS_ROWS_STYLE}>
        {fieldRows.map((row, index) => (
          <div key={index} css={FIELD_ROW_STYLE}>
            {row}
          </div>
        ))}
      </div>
    </div>
  </div>
);
